import { render, staticRenderFns } from "./AnimatedEnvelope.vue?vue&type=template&id=6950e820&scoped=true"
import script from "./AnimatedEnvelope.vue?vue&type=script&lang=js"
export * from "./AnimatedEnvelope.vue?vue&type=script&lang=js"
import style0 from "./AnimatedEnvelope.vue?vue&type=style&index=0&id=6950e820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6950e820",
  null
  
)

export default component.exports